// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {CallrailIntegrationModel} from '@supermove/models';

// App
import DeleteModal from '@shared/design/components/Modal/SmallModal/DeleteModal';
import DeleteCallrailIntegrationForm from '@shared/modules/CallrailIntegration/forms/DeleteCallrailIntegrationForm';
import useDeleteCallrailIntegrationMutation from '@shared/modules/CallrailIntegration/hooks/useDeleteCallrailIntegrationMutation';

interface DeleteCallrailIntegrationModalProps {
  callrailIntegration: CallrailIntegrationModel;
  isOpen: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

const DeleteCallrailIntegrationModal = ({
  callrailIntegration,
  isOpen,
  handleClose,
  onSuccess,
}: DeleteCallrailIntegrationModalProps) => {
  const {submitting, handleSubmit} = useDeleteCallrailIntegrationMutation({
    deleteCallrailIntegrationForm: DeleteCallrailIntegrationForm.new({
      callrailIntegrationId: callrailIntegration.id,
    }),
    onSuccess: () => {
      handleClose();
      onSuccess?.();
    },
    onError: (errors) => {
      console.error({errors});
    },
  });

  return (
    <DeleteModal
      isOpen={isOpen}
      handleClose={handleClose}
      handleDelete={handleSubmit}
      title={"Remove 'CallRail' Integration?"}
      subtitle={'This action cannot be undone.'}
      deleteButtonText={'Delete Integration'}
      cancelButtonText={'Cancel'}
      isSubmitting={submitting}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
DeleteCallrailIntegrationModal.fragment = gql`
  fragment DeleteCallrailIntegrationModal on CallrailIntegration {
    id
  }
`;

export default DeleteCallrailIntegrationModal;
